import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Text } from "@quintoandar-tokko/jopijs";
import style from "./edicionImages.module.scss";
import translations from "../FichaInfo.trans.json";
import Trans from "@/components/shared/Trans";
import { setEditedData } from "@/store/slices/components/fichaInfo/FichaInfoSlice";
import CardEdition from "@/components/imagesEdition/CardEdition";
import ImagesGalleryEdition from "@/components/imagesEdition/ImagesGalleryEdition";

export default function ImagesEdition() {
  const dispatch = useDispatch();
  const { origin_data, edited_data } = useSelector(
    (state) => state.FichaInfoSlice
  );
  const { images, blueprints, front_cover_image } = edited_data.pictures;

  const handleEditedImages = (newData) => {
    dispatch(
      setEditedData({
        key: "pictures",
        value: newData,
      })
    );
  };
  const handleEditedVideos = (check, file, type) => {
    dispatch(
      setEditedData({
        key: "videos",
        value: {
          ...edited_data.videos,
          [type]: check
            ? [...edited_data.videos[type], file]
            : edited_data.videos[type].filter((video) => video !== file),
        },
      })
    );
  };

  return (
    <Box className={style.mediaEditionContainer}>
      <Box className={style.imagesEditionContainer}>
        <Box __css={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <Text color="neutralGray1" fontWeight="700" variant="heading.1">
            {Trans(translations, "ImageEdition")}
          </Text>
          <Text color="neutralGray2" variant="body.fontSize14">
            {Trans(translations, "ImageEditionText")}
          </Text>
        </Box>
        <ImagesGalleryEdition
          allImages={origin_data.pictures.images}
          allBlueprints={origin_data.pictures.blueprints}
          originFrontCover={origin_data.pictures.front_cover_image}
          editedImages={images}
          editedBlueprints={blueprints}
          frontCover={front_cover_image}
          handleEditedImages={handleEditedImages}
        />
      </Box>
      <Box className={style.videoEditionContainer}>
        <Text fontWeight="700" color="neutralGray1" variant="body.fontSize16">
          {Trans(translations, "Videos")}
        </Text>
        <Box className={style.videoContainer}>
          {origin_data.videos.normal.map((video) => (
            <CardEdition
              key={video}
              file={video}
              check={edited_data.videos.normal.includes(video)}
              handleChange={handleEditedVideos}
              type="normal"
            />
          ))}
          {origin_data.videos["360"]?.map((video) => (
            <CardEdition
              key={video}
              file={video}
              check={edited_data.videos["360"].includes(video)}
              handleChange={handleEditedVideos}
              type="360"
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
}
